export type Contract = {
  id?: number;
  name?: string;
};

export class ContractClass implements Contract {
  id = 0;
  name = '';
}
